import Cookies from "universal-cookie";

/**
 *  Session Manager handles session requirements.
 *  If sessionStorage is available, uses it else uses cookies to store session info.
 * 
 */
const SessionManager = function () {
    let cookies = new Cookies();
    this.storeCookie = (key, val) => {
        const expires = new Date();
        expires.setMinutes(expires.getMinutes() + 30);
        val.token_expiry = expires.getTime();
        val.SameSite = "None";
        val.Secure = true;

        // if (key === 'user') {
        //     let zones = val.zones;
        //     if (zones && zones.length > 0) {
        //         for (let z of zones) {
        //             if (z['location_config']) {
        //                 delete z['location_config'];
        //             }
        //         }
        //     }
        //     let zone_selected = val.zone_selected;
        //     if (zone_selected && zone_selected['location_config'] !== undefined) {
        //         delete zone_selected['location_config'];
        //     }
        // }


        if (key === 'user' && val.site_selected && val.site_selected.customer_id)
            val.customer_id = val.site_selected.customer_id;

        if (sessionStorage) {
            if (key === 'user') {
                cookies.set('user_login', val.user_login);
                cookies.set('user_token', val.user_token);
                cookies.set('x-api-key', 'OIE3m9hJUI3egDNNU2mj1anJYK7FOJHm9J2DsznY');
                if (val.site_selected) {
                    if (val.site_selected.site_id === '8814987278636' || val.site_selected.site_id === '1573455425723') { // Demo account bypassing
                        cookies.set('site_id', '7777963129656');
                    } else {
                        cookies.set('site_id', val.site_selected.site_id);
                    }
                }
            }
            sessionStorage.setItem(key, JSON.stringify(val));
        } else {
            cookies.set(key, val,
                {
                    expires: expires,
                    path: '/',
                    maxAge: 1000,
                    httpOnly: true,
                    domain: "http://www.sitesupt.com"
                });
        }

        return val;
    };

    this.isExpired = (key) => {
        let obj = null;
        if (sessionStorage) {
            //console.log('Reading key \'' + key + '\' from sessionStorage');
            obj = JSON.parse(sessionStorage.getItem(key));
        } else {
            //console.log('Reading key \'' + key + '\'  from cookies');
            obj = cookies.get(key);
        }

        const isSessionValid = obj ? (obj.token_expiry - (new Date().getTime()) > 0) : false;
        if (!isSessionValid) {
            cookies.remove('user_login');
            cookies.remove('user_token');
            cookies.remove('x-api-key');
            cookies.remove('site_id');

            this.removeCookie(key);
            return null;
        } else {
            return this.storeCookie(key, obj);
        }
    }

    /**
     * Fetched obj if its not expired else returns null
     * 
     */
    this.readCookie = (key, isRedirect = true, redirectUrl = '/') => {
        var session_info = this.isExpired(key);

        if (isRedirect && session_info == null)
            window.location = window.location.origin + redirectUrl;

        return session_info;
    }

    this.removeCookie = (key) => {
        if (sessionStorage) {
            //console.log('Removing key \'' + key + '\' from sessionStorage');
            sessionStorage.removeItem(key);
        } else {
            //console.log('Removing key \'' + key + '\'  from cookies');
            cookies.remove(key);
        }
    }
}

export default SessionManager;